import { useNavigate, useLocation } from 'react-router-dom';
import { useUIState } from '../../contexts/UIStateContext';
import { IconButton } from './StandardButtons';

export default function HomeButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setChatLastConversation } = useUIState();

  const handleHomeClick = () => {
    // Clear the last conversation so it doesn't auto-restore
    setChatLastConversation(null);

    // If we're already at /home (with or without conversation), force a full page reload
    // This ensures WebSocket connection and state are fully reset
    if (location.pathname.startsWith('/home')) {
      window.location.href = '/home';
    } else {
      // Otherwise just navigate normally
      navigate('/home', { replace: true });
    }
  };

  return (
    <IconButton onClick={handleHomeClick} title="Home">
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    </IconButton>
  );
}
